import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from './ui/tooltip';
import { Button } from './ui/button';
import React from 'react';
import { cn } from '@/lib/utils';

export interface CheatActionProps {
  onClick: (event: any) => void;
  children: React.ReactNode;
  tooltip?: string;
  className?: string;
}

const cheatActionClass = `w-8 h-8`;

const CheatAction = (props: CheatActionProps) => {
  const { onClick, children, tooltip, className } = props;

  const button = (
    <Button
      className={cn(
        'cursor-pointer text-gray-500',
        cheatActionClass,
        className,
      )}
      variant="ghost"
      size="icon"
      onClick={onClick}
    >
      {children}
    </Button>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{button}</TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CheatAction;
